fragment imageDetailsList_item on ImageDetails {
	__typename
	id
	userEmailAddress
	description
	labels
	imageUrl
	createdAt
}